export default {
	tabs: ["Retirar", "Historial"],
	History: {
		tabs: ["Revisando", "Éxito", "Rechazado"]
	},
	Withdraw: {
		label: ["Número de cuenta", "N.º de orden", "Dirección", "Cantidad", "Tarifa", "Creado el", "Estado", "Razón"]
	},
	AccountAmount: "Cantidad de la cuenta",
	tips: "Recibirá su retiro dentro de una hora",
	form: {
		label: ["Cantidad a retirar", "Contraseña de transacción"],
		ALL: "TODO",
		Withdraw: "Enviar"
	},
	WithdrawAccount: "Cuenta de retiro",
	noAccountsTips: "Por favor, añada métodos de pago",
	tradingKind: [
		"Reembolso",
		"Deducción",
		"Recarga",
		"Retiro en curso",
		"Descongelación de retiro",
		"Retiro",
		"Tarea",
		"Devolución de capital",
		"Devolución de comisión",
		"Devolución de comisión subordinada",
		"Registro",
		"Tarifa de gestión",
		"Depósito",
		"Recompensa",
		"Salario base",
		"Asistencia en efectivo",
		"Bono de registro",
		"Dividendos de productos",
		"Bono por tarea",
		"Otros",
		"",
		"Bono laboral",
		"Recompensas por mejora",
		"Subsidio",
		"Verificación pendiente",
		"Campaña",
		"Canje de puntos",
		"Recompensas de inicio de sesión",
		"Recompensas laborales",
		"Transacción de puntuación crediticia"
	]
};
